<template>
  <div>
    <el-button-group class="button-group">
      <el-button type="default" @click="showModal()">
        + Dodaj rodzaj aktywności
      </el-button>
    </el-button-group>
    <el-dialog
      title="Tworzenie nowego rodzaju aktywności"
      append-to-body
      width="90vw"
      top="4vh"
      :visible.sync="modalVisible"
    >
      <event-activity-type-form in-modal @submit="submitForm()" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="hideModal()">Anuluj</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import EventActivityTypeForm from '../EventActivityTypeForm'

export default {
  components: { EventActivityTypeForm },
  data() {
    return {
      modalVisible: false
    }
  },
  methods: {
    showModal() {
      this.modalVisible = true
    },
    hideModal() {
      this.modalVisible = false
    },
    submitForm() {
      this.hideModal()
      this.$emit('reload')
    }
  }
}
</script>
<style lang="scss" scoped>
.button-group {
  display: flex;
  justify-content: flex-end;
  padding-bottom: 10px;
}
</style>
